import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import heroImage from '../images/hero.jpg'

const HeroWrapper = styled.div`
  min-height: 100vh;
  background-image: url(${heroImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

const HeroContainer = styled.div`
  max-width: 48em;
  margin-left: auto;
  margin-right: auto;
  padding: 4rem 2rem;
`

const Title = styled.div`
  padding-top: 4rem;
  padding-bottom: 4rem;
  mix-blend-mode: screen;
`

const HeroText = styled.div`
  color: white;

  @media (min-width: 40em) {
    font-size: 1.125rem;
  }
`

const Hero = ({ pages, language }) => {
  return (
    <HeroWrapper>
      {pages.filter(page => page.node.node_locale === language)
      .map(({ node: page }) => {
        return (
          <HeroContainer key={page.id}>
            <Title>
              <Img
                sizes={page.image.sizes}
                alt="Itsenäisen Suomen poliisi"
                title="Itsenäisen Suomen poliisi" />
            </Title>
            <HeroText dangerouslySetInnerHTML={{ __html: page.body.childMarkdownRemark.html }} />
          </HeroContainer>
        )
      })}
    </HeroWrapper>
  );
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/hero.js